import {Graphql} from '@hc/graphql'

export type CrudRelationRouterParams = {
  collection: string
  id: string|number
  relation: string
}

export type CrudCollectionRouterParams = {
  collection: string
}

export type CrudRouterParams = Record<string, any>

const routeGenerator = (routerParams: CrudRouterParams = {}) => {
  return (name: string, params: CrudRouterParams = {}, query?: CrudRouterParams) => {
    return {
      name,
      params: {
        ...routerParams,
        ...params
      },
      query: query
    }
  }
}

export function useCrudRelationRouter(params: CrudRelationRouterParams){
  const {collection, id, relation} = params
  const route = routeGenerator({collection, id, relation})
  const index = () => route('crud.relation')
  const up = (o: any) => route('crud.object', {relation: null})
  const create = () => route('crud.relation.create')
  const view = (o: any) => route('crud.relation.object', {itemId: o.id})
  const edit = (o: any) => route('crud.relation.edit', {itemId: o.id})
  return {route, index, up, create, view, edit}
}

export function useCrudCollectionRouter(params: CrudCollectionRouterParams){
  const {collection: collectionName} = params
  const collection = Graphql.collection(collectionName)
  const route = routeGenerator({collection: collectionName})
  const index = () => route('crud.list')
  const up = (o: any) => {
    const parent = collection.parent && o && o[collection.parent] ? o[collection.parent] : null
    if(parent){
      const parentCollection = collection.parentCollection
      return route('crud.object', {collection: parentCollection.name, id: parent.id})
    } else {
      return route('crud.list')
    }
  }
  const create = () => route('crud.create')
  const view = (o: any) => route('crud.object', {id: o.id})
  const edit = (o: any) => route('crud.edit', {id: o.id})
  return {route, index, up, create, view, edit}
}